import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Growler from './GrowlerComponent';
import * as growlerActionCreators from './actions';
import { selectErrorText, selectErrorStatus, selectAction } from './selectors';
import { createStructuredSelector } from 'reselect';

const GrowlerContainer = (props) => {
  const { errorText, errorStatus, selectAction } = props;
  return <Growler status={errorStatus} message={errorText} action={selectAction} />;
};

const mapStateToProps = createStructuredSelector({
  errorText: selectErrorText(),
  errorStatus: selectErrorStatus(),
  selectAction: selectAction(),
});
const mapDispatchToProps = (dispatch) => {
  return {
    abortDownload: dispatch(growlerActionCreators.showGrowlerAbort("ABORTED BY THE USER"))
  };
};

GrowlerContainer.propTypes = {
  errorText: PropTypes.string,
  errorStatus: PropTypes.string,
  selectAction:PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(GrowlerContainer);



// WEBPACK FOOTER //
// ./src/containers/Notification/index.js